// BaseModal.tsx
import React from 'react';
import { Modal } from 'react-bootstrap';

interface BaseModalProps {
  show: boolean;
  onHide: () => void;
  children?: React.ReactNode;
  scrollable?: boolean;
}

const BaseModal: React.FC<BaseModalProps> = ({
  show,
  onHide,
  children,
  scrollable = false,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      centered
      backdrop="static"
      keyboard
      scrollable={scrollable}
    >
      {children}
    </Modal>
  );
};

export default BaseModal;
